import { useExportPlaces } from "@/mutations/useExportPlaces.tsx";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Button, CircularProgress } from "@mui/material";

const ExportPlaces = () => {
    const exportPlaces = useExportPlaces();

    const handleExportData = () => {
        exportPlaces.mutate();
    };

    return (
        <Button
            onClick={handleExportData}
            startIcon={
                exportPlaces.isPending ? <CircularProgress size={16} /> : <FileDownloadIcon />
            }
            variant="contained"
            size="small"
            disabled={exportPlaces.isPending}
        >
            {exportPlaces.isPending ? "Exporting..." : "Export"}
        </Button>
    );
};

export default ExportPlaces;
